<div class="dashboard container">

    <ng-container *ngIf="carregando">
        <div class="state-message">Carregando seu progresso...</div>
    </ng-container>

    <ng-container *ngIf="!carregando && erro">
        <div class="state-message error">
            Não foi possível carregar seu dashboard agora.
            <button type="button" (click)="carregar()">Tentar novamente</button>
        </div>
    </ng-container>

    <ng-container *ngIf="!carregando && !erro && dashboard as d">

        <section class="hero">
            <div>
                <p class="eyebrow">Dashboard de Evolucao</p>
                <h1>Seu Progresso em 90 Dias</h1>
                <p class="subtitle">Acompanhe consistencia, volume de treino e recordes com base nas suas execucoes registradas.</p>
            </div>

            <div class="hero-badge">
                <span>Aderencia (ultimas 4 semanas)</span>
                <strong>{{ d.kpis.aderenciaUltimas4Semanas }}%</strong>
            </div>
        </section>

        <ng-container *ngIf="!temDados">
            <section class="empty-state">
                <p>Voce ainda nao tem treinos configurados ou execucoes registradas.</p>
                <p>Configure um treino e registre suas execucoes para ver seu progresso aqui.</p>
            </section>
        </ng-container>

        <ng-container *ngIf="temDados">

            <section class="kpi-grid">
                <article class="kpi-card">
                    <span class="kpi-label">Execucoes de Treinos</span>
                    <strong class="kpi-value">{{ d.kpis.execucoesUltimos90Dias }}</strong>
                    <p class="kpi-trend" [class.up]="(d.kpis.execucoesVariacaoPercentual ?? 0) >= 0" [class.down]="(d.kpis.execucoesVariacaoPercentual ?? 0) < 0">
                        {{ formatarVariacao(d.kpis.execucoesVariacaoPercentual) }}
                    </p>
                </article>

                <article class="kpi-card">
                    <span class="kpi-label">Carga Total Levantada</span>
                    <strong class="kpi-value">{{ formatarPeso(d.kpis.cargaTotalUltimos90Dias) }}</strong>
                    <p class="kpi-trend" [class.up]="(d.kpis.cargaVariacaoPercentual ?? 0) >= 0" [class.down]="(d.kpis.cargaVariacaoPercentual ?? 0) < 0">
                        {{ formatarVariacao(d.kpis.cargaVariacaoPercentual) }}
                    </p>
                </article>

                <article class="kpi-card">
                    <span class="kpi-label">Aderencia ao Plano</span>
                    <strong class="kpi-value">{{ d.kpis.aderenciaUltimas4Semanas }}%</strong>
                    <p class="kpi-trend up">nas ultimas 4 semanas</p>
                </article>

                <article class="kpi-card">
                    <span class="kpi-label">Sequencia Acima da Meta</span>
                    <strong class="kpi-value">{{ d.kpis.semanasConsecutivasAcimaDaMeta }}</strong>
                    <p class="kpi-trend up">semanas consecutivas &ge; 80%</p>
                </article>
            </section>

            <section class="main-grid">
                <article class="panel evolution">
                    <header class="panel-header">
                        <h2>Volume de Treino</h2>
                        <span>Ultimas 8 semanas</span>
                    </header>

                    <div class="chart-row">
                        <span>Execucoes</span>
                        <div class="bars">
                            <i *ngFor="let b of barras" [style.height.%]="b.execucoesPct" [title]="b.label"></i>
                        </div>
                    </div>

                    <div class="chart-row">
                        <span>Carga (kg)</span>
                        <div class="bars accent">
                            <i *ngFor="let b of barras" [style.height.%]="b.cargaPct" [title]="b.label"></i>
                        </div>
                    </div>

                    <div class="chart-row">
                        <span>Cardio (km)</span>
                        <div class="bars positive">
                            <i *ngFor="let b of barras" [style.height.%]="b.cardioPct" [title]="b.label"></i>
                        </div>
                    </div>
                </article>

                <article class="panel side">
                    <div class="adherence">
                        <h2>Consistencia Mensal</h2>
                        <div class="ring" [style.background]="'conic-gradient(#2b9d66 0 ' + d.aderenciaUltimoMes + '%, #ecf4ef ' + d.aderenciaUltimoMes + '% 100%)'">
                            <strong>{{ d.aderenciaUltimoMes }}%</strong>
                            <span>meta concluida</span>
                        </div>
                    </div>

                    <div class="mini-list">
                        <h3>Recordes Recentes</h3>
                        <ul *ngIf="recordes.length; else semRecordes">
                            <li *ngFor="let r of recordes">
                                <span>{{ r.exercicioNome }}</span>
                                <strong>{{ formatarPeso(r.cargaMaxima) }}</strong>
                            </li>
                        </ul>
                        <ng-template #semRecordes>
                            <p class="empty-hint">Registre execucoes com carga para ver seus recordes aqui.</p>
                        </ng-template>
                    </div>
                </article>
            </section>

            <section class="lower-grid">
                <article class="panel">
                    <header class="panel-header">
                        <h2>Ultimas Execucoes</h2>
                        <span>Historico recente</span>
                    </header>

                    <div class="table-wrap">
                        <table *ngIf="d.ultimasExecucoes.length; else semExecucoes">
                            <thead>
                                <tr>
                                    <th>Data</th>
                                    <th>Treino</th>
                                    <th>Exercicios</th>
                                    <th>Carga Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let e of d.ultimasExecucoes">
                                    <td>{{ formatarData(e.data) }}</td>
                                    <td>{{ e.treinoNome }}</td>
                                    <td>{{ e.quantidadeExercicios }}</td>
                                    <td>{{ e.cargaTotal ? formatarPeso(e.cargaTotal) : '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <ng-template #semExecucoes>
                            <p class="empty-hint">Nenhuma execucao registrada ainda.</p>
                        </ng-template>
                    </div>
                </article>

                <article class="panel timeline">
                    <header class="panel-header">
                        <h2>Marcos de Evolucao</h2>
                        <span>Linha do tempo</span>
                    </header>

                    <ul *ngIf="marcos.length; else semMarcos">
                        <li *ngFor="let m of marcos">
                            <small>{{ formatarData(m.data) }}</small>
                            <p>{{ m.descricao }}</p>
                        </li>
                    </ul>
                    <ng-template #semMarcos>
                        <p class="empty-hint">Seus marcos de evolucao aparecerao aqui conforme voce treina.</p>
                    </ng-template>
                </article>
            </section>

        </ng-container>

    </ng-container>
</div>
